import {Injectable, OnInit, signal} from '@angular/core';
import {School, SchoolClass, SchoolType} from "../models/school.obj";
import {Observable} from "rxjs";
import _ from "lodash";
import {map, tap} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {CacheService} from "@customcoding/shared";
import {FormGroup} from "@angular/forms";

@Injectable({
	providedIn: 'root'
})
export class SchoolService implements OnInit {

	allSchools = signal<School[]>([]);
	allSchoolTypes = signal<SchoolType[]>([]);
	allSchoolClasses = signal<SchoolClass[]>([]);
	constructor(private http: HttpClient, private cache: CacheService) {

	/*
		this.getAll().subscribe();
		this.getClasses().subscribe();
		this.getTypes().subscribe();
	*/
	}

	ngOnInit(): void {

	}
	private static groupClasses(classes: SchoolClass[]): { [type: number]: SchoolClass[] } {
		const test = _.groupBy(classes, 'schoolType_id');
	return test;
	}

	public getAll(force:boolean = true): Observable<School[]> {

		const apiUrl = `/api/scap/school?isPaginated=0`;
		if(force)
			this.cache.invalidate(apiUrl);

		return this.cache.get<School[]>(apiUrl).pipe(
			tap(schools => this.allSchools.set(schools))
		);
	}

	public getTypes(): Observable<SchoolType[]> {
		return this.cache.get<SchoolType[]>("/api/scap/school-type?isPaginated=0").pipe(
			tap(types => this.allSchoolTypes.set(types))
		);
	}

	public getDirections(): Observable<IdAndName[]> {
		return this.cache.get("/api/scap/school-direction?isPaginated=0");
	}

	public getClasses(): Observable<SchoolClass[]> {
		return this.cache.get<SchoolClass[]>("/api/scap/school-class").pipe(
			tap(classes => this.allSchoolClasses.set(classes))
		);
	}

	public groupedClasses(): Observable<{ [type: number]: SchoolClass[] }> {
		return this.getClasses().pipe(map(c => SchoolService.groupClasses(c)));
	}

	existsOnBackend(value: { id: number | string }): boolean {
		return value.id && !String(value.id).startsWith('unsaved_');
	}

	mergeSchools(mainSchoolId: number, formGroup: FormGroup) {

		let values = formGroup.value

		return this.http.patch(`/api/scap/school/${mainSchoolId}/merge-with-other-schools`, values);
	}

}

type IdAndName = { id: number, name: string };
